import {EServiceName} from "../types/enum";

export const MOBILE_WIDTH_PX = 1279;
export const LAYOUT_DESKTOP_MIN_WIDTH_PX = MOBILE_WIDTH_PX + 1;

export const SNAP_THRESHOLD = 0.85;
export const SNAP_DURATION_MS = 1300;

export const CASES_LIMIT = 5;

export const SERVICE_CONSUMER_PROMO = {
  title: "потребительский маркетинг",
  description:
    "Проехать на траке 15 тысяч километров и провести 200 мероприятий за тур или построить бренд-зону в 8 городах сразу и собрать 1 млн визуальных контактов — можем и делали. Все: от идеи до бесперебойной логистики и результатов в отчете.",
  name: EServiceName.CONSUMER_PROMO,
};

export const SERVICE_SPORT_MARKETING = {
  title: "спортивный маркетинг",
  description:
    "Перерыв короткий, сезон длинный. Делаем так, чтобы бренд запомнили: строим гигантский QR-код для СБП или проводим автограф-сессию с чемпионкой России и получаем 6,6 тысяч регистраций за сезон.",
  name: EServiceName.SPORT_MARKETING,
};

export const SERVICE_EVENT_MARKETING = {
  title: "событийный маркетинг",
  description:
    "Больше 12 лет команда делает невозможное возможным: ракету в космос запускали, олимпийский огонь зажигали, кубок FIFA всему миру показывали - и все ради решения бизнес-задач брендов, а сегодня мы знаем, что ивент - это новое медиа!",
  name: EServiceName.EVENT_MARKETING,
};
